// extracted by mini-css-extract-plugin
export default {"errCont":"ErrorLineItem_errCont__zbhFJ","isErr":"ErrorLineItem_isErr__-jRUV","isGood":"ErrorLineItem_isGood__nNC3o"};